// Patient filter options
export enum PatientFilterType {
  AGE = 'Age',
  WEIGHT = 'Weight',
  SPECIES = 'Species',
  SEX = 'Sex',
}

export const PatientFilterLabel = {
  [PatientFilterType.AGE]: 'Age',
  [PatientFilterType.WEIGHT]: 'Weight',
  [PatientFilterType.SPECIES]: 'Species',
  [PatientFilterType.SEX]: 'Sex',
}

// Appointment filter options
export enum AppointmentFilterType {
  CURRENT_APPOINTMENT_TYPE = 'current-appointment-type',
}

export const AppointmentFilterLabel = {
  [AppointmentFilterType.CURRENT_APPOINTMENT_TYPE]: 'Current Appointment Type',
}

// Default filter data for charge search
export const DEFAULT_CHARGE_SEARCH_FILTERS = {
  patient: [
    {
      id: PatientFilterType.AGE,
      label: PatientFilterLabel[PatientFilterType.AGE],
      value: PatientFilterType.AGE,
      enabled: true,
    },
    {
      id: PatientFilterType.WEIGHT,
      label: PatientFilterLabel[PatientFilterType.WEIGHT],
      value: PatientFilterType.WEIGHT,
      enabled: true,
    },
    {
      id: PatientFilterType.SPECIES,
      label: PatientFilterLabel[PatientFilterType.SPECIES],
      value: PatientFilterType.SPECIES,
      enabled: true,
    },
    {
      id: PatientFilterType.SEX,
      label: PatientFilterLabel[PatientFilterType.SEX],
      value: PatientFilterType.SEX,
      enabled: true,
    },
  ],
  appointment: [
    {
      id: AppointmentFilterType.CURRENT_APPOINTMENT_TYPE,
      label:
        AppointmentFilterLabel[AppointmentFilterType.CURRENT_APPOINTMENT_TYPE],
      value: AppointmentFilterType.CURRENT_APPOINTMENT_TYPE,
      enabled: true,
    },
  ],
}
